module.exports = __webpack_public_path__ + "img/图2.7194751c.png";